import { useQuery } from 'react-query';

import { customInstance } from '@ping/api/custom-instance';

import type { IKybBusinessStatus } from './status-screen';

export const KYB_BUSINESS_STATUS_PATH = '/frontoffice/api/kyb/business/status';

export const kybBusinessStatusQueryKey = ['kyb', 'business', 'status'] as const;

export const getKybBusinessStatus = () =>
  customInstance<IKybBusinessStatus>({ url: KYB_BUSINESS_STATUS_PATH, method: 'GET' });

export const useKybBusinessStatus = (options?: { enabled?: boolean }) =>
  useQuery(kybBusinessStatusQueryKey, () => getKybBusinessStatus(), {
    refetchOnWindowFocus: true,
    enabled: options?.enabled ?? true,
  });
